import React from "react";
import { PageType } from ".";
interface PlusEssentialsPhase5AdProps {
  name: string;
  dollarAmountSaved: number;
  backgroundImage: string;
  couponCode: string;
  endDate: string;
  link: string;
  mobileBackgroundImage: string;
  trackingName: string;
  pageType: PageType;
  className: string;
}
const PlusEssentialsPhase5Ad = ({
  name,
  dollarAmountSaved,
  backgroundImage,
  couponCode,
  endDate,
  link,
  mobileBackgroundImage,
  trackingName,
  pageType,
  className
}: PlusEssentialsPhase5AdProps) => {
  const isHomepage = pageType === "Home";
  const isMyAccount = pageType === "MyAccount";
  return <div className="h-fit" data-sentry-component="PlusEssentialsPhase5Ad" data-sentry-source-file="PlusEssentialsPhase5Ad.tsx">
      <a href={link} className={className} id={trackingName} data-testid={trackingName}>
        <div className="mx-auto
                    mt-8
                    mb-2
                    relative
                    overflow-hidden
                    rounded
                    bg-[#06142B]
                    flex
                    flex-col
                    xs:flex-row
                    justify-between">
          <div className="relative z-10">
            <div className={`pt-6
                        px-6
                        pb-0
                        xs:pb-6
                        ${isHomepage ? "xs:pr-0 md:pr-0 lt:pr-0" : "xs:pr-6 md:pr-10 lt:pr-4"}
                        md:p-[28px]
                        lt:p-8
                        `}>
              <div className="w-full
                          text-center
                          xs:text-left
                          flex
                          flex-col
                          items-center
                          xs:items-start">
                <p data-testid={`${trackingName}-headline`} className={`text-white
                            font-bold
                            text-2xl
                            leading-none
                            mb-2
                            mx-0
                            text-wrap
                            w-[319px]
                            xsl:w-[372px]
                            ${isHomepage ? "lt:w-[558px] lt:text-[42px] lt:leading-10" : "whitespace-nowrap lt:w-full lt:text-[30px] lt:leading-7"}`}>
                  Our Treat: ${dollarAmountSaved} in FREE <br />
                  {name} Essentials!
                </p>
                <p className="text-base
                  leading-5
                  md:text-base
                  font-normal
                  text-white
                  text-wrap
                  w-[234px]
                  xsl:w-[334px]
                  lt:w-[360px]
                  mb-6">
                  <span>
                    With no minimum purchase, this deal is perfect for
                    restocking your favorite items.
                  </span>
                </p>
                <div className="flex flex-col xs:flex-row items-center gap-x-4">
                  <span className="bg-[#3DCAFF]
                              hover:bg-[#37B7E6]
                              text-[#06142B]
                              font-semibold
                              px-6
                              py-2
                              rounded
                              text-xs
                              sm:text-sm
                              md:text-base
                              whitespace-nowrap">
                    Use Code: {couponCode}
                  </span>
                  <div className="flex
                              flex-col
                              mt-4
                              text-white
                              items-left
                              justify-center
                              sm:items-start
                              xs:mt-0">
                    <span className="text-sm font-bold leading-[15px]">
                      Offer ends {endDate}
                    </span>
                    <span className={`
                        text-xs 
                        font-normal 
                        ${isMyAccount ? "whitespace-nowrap" : ""}
                      `}>
                      Limited Time, Single Use Code
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="relative
                      w-full
                      xs:w-1/2
                      lt:w-2/5
                      xl:w-1/2
                      z-10
                      overflow-visible
                      mt-0
                      md:mr-[-50px]
                      lt:mr-0">
            <img className="block xs:hidden w-full" src={mobileBackgroundImage} alt="" />
            <img className={`absolute
                        z-0
                        hidden
                        xs:block
                        aspect-auto
                        object-cover
                        object-left
                        h-full
                        w-full
                        ${isHomepage ? "xxl:object-right xxl:object-contain" : "xxxl:object-right xxxl:object-contain"}`} src={backgroundImage} alt="" />
          </div>
        </div>
      </a>
    </div>;
};
export default PlusEssentialsPhase5Ad;